export default "__VITE_ASSET__YOdii7J9__"